/* l1.js: Verhalten der l1-Produktseite (l1.zzzlim.de) ohne React.
   Nachgebaut aus peitho-lp-v2 (origin/main, Stand 2026-09-29):
   BuyboxSubscribeSticky, StickyBuyBar, NavbarMenuSticky, ProductGalleryRail,
   ImageZoom, VideoModal, IngredientsGridModal, ProblemStatCards, ReviewWall,
   ScrollReveal, lib/checkout.ts (UTM), lib/versandtag.ts, lib/pdp-preis.ts.
   Bewusst NICHT enthalten: Meta-/GA-Pixel, metaCheckoutIntent, lp_events,
   Android-Chrome-Weiche, A/B-Test, Kassen-Rueckkehr-Umfrage, eigener
   Cookie-Banner (Shopify-Apps uebernehmen Pixel und Einwilligung). */
(function () {
  "use strict";

  var cfgEl = document.getElementById("l1-config");
  var root = document.querySelector("main.lp-root");
  if (!cfgEl || !root) return;
  var cfg = JSON.parse(cfgEl.textContent);

  // ---------- Hilfen ----------
  function euro(n) { return n.toFixed(2).replace(".", ",") + " €"; }
  function priceValue(s) {
    var m = String(s).replace(/\s/g, "").match(/(\d+(?:[.,]\d{1,2})?)/);
    return m ? Number(m[1].replace(",", ".")) : 0;
  }
  // Shopify rundet den RABATTBETRAG ab, nicht die Summe (lib/pdp-preis.ts).
  function mitCode(cents) {
    var p = Math.max(0, Math.min(100, cfg.promoPct || 0));
    return cents - Math.floor((cents * p) / 100);
  }
  var bodyLocks = 0, bodyPrev = "";
  function lockBody() { if (bodyLocks++ === 0) { bodyPrev = document.body.style.overflow; document.body.style.overflow = "hidden"; } }
  function unlockBody() { if (bodyLocks > 0 && --bodyLocks === 0) document.body.style.overflow = bodyPrev; }

  // ---------- Warenkorb-Link (lib/checkout.ts) ----------
  var UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid", "gclid", "ttclid", "msclkid", "mc"];
  function readUtm(search) {
    var p = new URLSearchParams(search), out = {};
    UTM_KEYS.forEach(function (k) { var v = p.get(k); if (v) out[k] = v; });
    return out;
  }
  var utm = readUtm(window.location.search);
  function permalink(variantId, qty) {
    var params = new URLSearchParams();
    if (cfg.promoCode) params.set("discount", cfg.promoCode);
    if (cfg.campaignCategory) params.set("attributes[campaign_category]", cfg.campaignCategory);
    Object.keys(utm).forEach(function (k) { params.set("attributes[" + k + "]", utm[k]); });
    ["utm_source", "utm_medium", "utm_campaign", "utm_content"].forEach(function (k) { if (utm[k]) params.set(k, utm[k]); });
    return "/cart/" + variantId + ":" + (qty || 1) + "?" + params.toString();
  }

  // ---------- Versandtag (lib/versandtag.ts, Zeitzone Europe/Berlin) ----------
  function ostersonntag(j) {
    var a = j % 19, b = Math.floor(j / 100), c = j % 100, d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    var monat = Math.floor((h + l - 7 * m + 114) / 31), tag = ((h + l - 7 * m + 114) % 31) + 1;
    return Date.UTC(j, monat - 1, tag, 12);
  }
  var TAG = 86400000;
  function key(t) { var d = new Date(t); return d.getUTCFullYear() + "-" + (d.getUTCMonth() + 1) + "-" + d.getUTCDate(); }
  function feiertage(j) {
    var o = ostersonntag(j);
    return [Date.UTC(j, 0, 1, 12), o - 2 * TAG, o + TAG, Date.UTC(j, 4, 1, 12), o + 39 * TAG, o + 50 * TAG,
      Date.UTC(j, 9, 3, 12), Date.UTC(j, 11, 25, 12), Date.UTC(j, 11, 26, 12)].map(key);
  }
  function istWerktag(t) {
    var d = new Date(t), wt = d.getUTCDay();
    if (wt === 0 || wt === 6) return false;
    return feiertage(d.getUTCFullYear()).indexOf(key(t)) === -1;
  }
  function versandtagText() {
    var parts = {};
    new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/Berlin", year: "numeric", month: "numeric", day: "numeric", hour: "numeric", hourCycle: "h23" })
      .formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    var t = Date.UTC(+parts.year, +parts.month - 1, +parts.day, 12);
    if (+parts.hour >= 14) t += TAG; // Annahmeschluss 14 Uhr
    while (!istWerktag(t)) t += TAG;
    return new Date(t).toLocaleDateString("de-DE", { weekday: "short", day: "numeric", month: "short", timeZone: "UTC" });
  }

  // ---------- Kaufkasten ----------
  var offer = document.getElementById("offer-1");
  if (offer) {
    var q = function (s) { return offer.querySelector(s); };
    var packBtns = offer.querySelectorAll("[data-l1-pack]");
    var buy = q('a[data-cta="buy"]');
    var selectPack = function (idx) {
      var p = cfg.packs[idx];
      if (!p) return;
      Array.prototype.forEach.call(packBtns, function (b, i) {
        var on = i === idx;
        b.setAttribute("aria-pressed", on ? "true" : "false");
        b.style.border = "1.5px solid " + (on ? "var(--lp-text)" : "var(--lp-border)");
        b.style.background = on ? "var(--lp-surface-2)" : "var(--lp-bg)";
      });
      var listCents = Math.round(priceValue(p.price) * 100);
      var payCents = mitCode(listCents);
      var list = q('[data-l1="once-list"]'), price = q('[data-l1="once-price"]');
      if (list) { list.textContent = euro(listCents / 100); list.hidden = !(payCents < listCents); }
      if (price) price.textContent = euro(payCents / 100);
      var saved = (listCents - payCents) / 100;
      var row = q('[data-l1="saved-row"]');
      if (row) {
        row.hidden = !(saved > 0.004);
        q('[data-l1="saved-list"]').textContent = euro(listCents / 100);
        q('[data-l1="saved"]').textContent = "Du sparst " + euro(saved);
      }
      if (buy) {
        var label = buy.querySelector('[data-l1="buy-label"]');
        if (label) label.textContent = cfg.cta + " | " + euro(payCents / 100);
        buy.href = permalink(p.variantId, 1);
      }
    };
    Array.prototype.forEach.call(packBtns, function (b) {
      b.addEventListener("click", function () { selectPack(Number(b.getAttribute("data-l1-pack"))); });
    });
    selectPack(0);

    var ships = q('[data-l1="ships"]');
    if (ships) { try { ships.textContent = versandtagText(); } catch (e) { /* ohne Datum */ } }

    // Scroll-Kopplung ab 900px: Seiten-Scroll treibt den Innen-Scroll des Kastens.
    var box = q(".pdp-sub-col");
    var track = box ? box.closest("[data-lp-section]") : null;
    if (box && track) {
      var mq900 = window.matchMedia("(min-width: 900px)");
      var offset = 0, lastMapped = 0, setting = false;
      window.addEventListener("scroll", function () {
        if (!mq900.matches) return;
        var max = box.scrollHeight - box.clientHeight;
        if (max <= 0) return;
        var mapped = Math.max(0, Math.min(max, -track.getBoundingClientRect().top));
        lastMapped = mapped;
        var want = Math.max(0, Math.min(max, mapped + offset));
        if (Math.abs(box.scrollTop - want) > 1) { setting = true; box.scrollTop = want; }
      }, { passive: true });
      box.addEventListener("scroll", function () {
        if (setting) { setting = false; return; }
        offset = box.scrollTop - lastMapped;
      }, { passive: true });
    }
  }

  // ---------- Kaufleiste unten ----------
  var bar = document.querySelector(".lp-stickybar");
  if (bar) {
    var barLink = bar.querySelector('a[data-cta="sticky-buy"]');
    var barBtns = bar.querySelectorAll(".lp-stickybar-paket");
    var nacht = bar.querySelector(".lp-stickybar-nacht");
    var show = false, dismissed = false;
    var paint = function () {
      var vis = show && !dismissed;
      bar.style.transform = vis ? "translateY(0)" : "translateY(110%)";
      bar.setAttribute("aria-hidden", vis ? "false" : "true");
    };
    var selectBar = function (idx) {
      var p = cfg.packs[idx];
      if (!p) return;
      Array.prototype.forEach.call(barBtns, function (b, i) {
        b.setAttribute("aria-pressed", i === idx ? "true" : "false");
        b.classList.toggle("lp-stickybar-paket--an", i === idx);
      });
      var payCents = mitCode(Math.round(priceValue(p.price) * 100));
      if (nacht) nacht.textContent = euro(Math.round(payCents / (p.units * 30)) / 100) + " pro Nacht";
      if (barLink) {
        barLink.textContent = cfg.stickyCta + " · " + euro(payCents / 100);
        barLink.href = permalink(p.variantId, 1);
      }
    };
    Array.prototype.forEach.call(barBtns, function (b, i) { b.addEventListener("click", function () { selectBar(i); }); });
    selectBar(0);
    var closeBtn = bar.querySelector('button[aria-label="Buy-Bar schließen"]');
    if (closeBtn) closeBtn.addEventListener("click", function () { dismissed = true; paint(); });
    // Erscheint ab 25 % der Scroll-Hoehe, mindestens nach 400px (Variante A).
    var onScrollBar = function () {
      var scrollable = document.documentElement.scrollHeight - window.innerHeight;
      var next = window.scrollY > Math.max(400, scrollable * 0.25);
      if (next !== show) { show = next; paint(); }
    };
    onScrollBar();
    window.addEventListener("scroll", onScrollBar, { passive: true });
  }

  // ---------- Navigation: Hide-on-Scroll (ab 768px) + Schublade ----------
  var header = document.querySelector("#navbar-1 header");
  if (header) {
    var mq768 = window.matchMedia("(min-width: 768px)");
    var lastY = window.scrollY;
    window.addEventListener("scroll", function () {
      var y = window.scrollY;
      if (!mq768.matches) { header.style.transform = "translateY(0)"; lastY = y; return; }
      var delta = y - lastY;
      if (y < 80) header.style.transform = "translateY(0)";
      else if (delta > 6) header.style.transform = "translateY(-110%)";
      else if (delta < -6) header.style.transform = "translateY(0)";
      lastY = y;
    }, { passive: true });
    var logo = header.querySelector('a[href="#"]');
    if (logo) logo.addEventListener("click", function (e) { e.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); });
  }
  var drawer = document.getElementById("l1-drawer");
  var drawerBack = document.getElementById("l1-drawer-back");
  var burger = document.querySelector('#navbar-1 button[aria-label="Menü öffnen"]');
  if (drawer && burger) {
    var drawerOpen = false;
    var onDrawerKey = function (e) { if (e.key === "Escape") setDrawer(false); };
    var setDrawer = function (open) {
      if (open === drawerOpen) return;
      drawerOpen = open;
      drawer.style.transform = open ? "translateX(0)" : "translateX(-102%)";
      drawer.style.visibility = open ? "visible" : "hidden";
      if (drawerBack) drawerBack.hidden = !open;
      burger.setAttribute("aria-expanded", open ? "true" : "false");
      if (open) { lockBody(); window.addEventListener("keydown", onDrawerKey); }
      else { unlockBody(); window.removeEventListener("keydown", onDrawerKey); }
    };
    burger.addEventListener("click", function () { setDrawer(true); });
    if (drawerBack) drawerBack.addEventListener("click", function () { setDrawer(false); });
    var closeD = drawer.querySelector('button[aria-label="Menü schließen"]');
    if (closeD) closeD.addEventListener("click", function () { setDrawer(false); });
    Array.prototype.forEach.call(drawer.querySelectorAll("a[href]"), function (a) {
      a.addEventListener("click", function (e) {
        var href = a.getAttribute("href");
        if (href.charAt(0) === "#") {
          e.preventDefault();
          setDrawer(false);
          var t = document.querySelector(href);
          if (t) t.scrollIntoView({ behavior: "smooth" });
        } else setDrawer(false);
      });
    });
    var sel = drawer.querySelector("select");
    if (sel) sel.addEventListener("change", function () { if (sel.value) window.location.href = sel.value; });
  }

  // ---------- Bild-Lightbox (ImageZoom) ----------
  var SVG_PREV = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 5-7 7 7 7"></path></svg>';
  var SVG_NEXT = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 5 7 7-7 7"></path></svg>';
  function openZoom(bilder, start) {
    var aktiv = start, n = bilder.length, mehrere = n > 1;
    var el = document.createElement("div");
    el.className = "lp-imgzoom-backdrop";
    el.setAttribute("role", "dialog");
    el.setAttribute("aria-modal", "true");
    var h = '<button type="button" aria-label="Schließen" class="lp-imgzoom-close">×</button><img class="lp-imgzoom-img" draggable="false" alt="">';
    if (mehrere) {
      h += '<button type="button" class="lp-imgzoom-nav lp-imgzoom-nav--prev" aria-label="Vorheriges Bild">' + SVG_PREV + "</button>" +
        '<button type="button" class="lp-imgzoom-nav lp-imgzoom-nav--next" aria-label="Nächstes Bild">' + SVG_NEXT + "</button>" +
        '<div class="lp-imgzoom-punkte" role="tablist" aria-label="Bild wählen">';
      for (var i = 0; i < n; i++) h += '<button type="button" aria-label="Bild ' + (i + 1) + " von " + n + '" class="lp-imgzoom-punkt"></button>';
      h += "</div>";
    }
    el.innerHTML = h;
    var img = el.querySelector(".lp-imgzoom-img");
    var dots = el.querySelectorAll(".lp-imgzoom-punkt");
    var render = function () {
      img.src = bilder[aktiv].src;
      img.alt = bilder[aktiv].alt || "";
      if (mehrere) el.setAttribute("aria-label", "Bild " + (aktiv + 1) + " von " + n);
      Array.prototype.forEach.call(dots, function (d, i) {
        d.setAttribute("aria-pressed", i === aktiv ? "true" : "false");
        d.className = i === aktiv ? "lp-imgzoom-punkt lp-imgzoom-punkt--an" : "lp-imgzoom-punkt";
      });
    };
    var geh = function (s) { aktiv = (aktiv + s + n) % n; render(); };
    var close = function () {
      document.removeEventListener("keydown", onKey);
      if (el.parentNode) el.parentNode.removeChild(el);
      unlockBody();
    };
    var onKey = function (e) {
      if (e.key === "Escape") close();
      else if (e.key === "ArrowRight") geh(1);
      else if (e.key === "ArrowLeft") geh(-1);
    };
    var wisch = null;
    el.addEventListener("pointerdown", function (e) { wisch = { x: e.clientX, y: e.clientY }; });
    el.addEventListener("pointerup", function (e) {
      if (!wisch || !mehrere) return;
      var dx = e.clientX - wisch.x;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(e.clientY - wisch.y)) { geh(dx < 0 ? 1 : -1); wisch = { x: -9999, y: -9999 }; }
    });
    el.addEventListener("click", function () {
      var s = wisch; wisch = null;
      if (s && s.x === -9999) return;
      close();
    });
    img.addEventListener("click", function (e) { e.stopPropagation(); });
    el.querySelector(".lp-imgzoom-close").addEventListener("click", function (e) { e.stopPropagation(); close(); });
    if (mehrere) {
      el.querySelector(".lp-imgzoom-nav--prev").addEventListener("click", function (e) { e.stopPropagation(); geh(-1); });
      el.querySelector(".lp-imgzoom-nav--next").addEventListener("click", function (e) { e.stopPropagation(); geh(1); });
      el.querySelector(".lp-imgzoom-punkte").addEventListener("click", function (e) { e.stopPropagation(); });
      Array.prototype.forEach.call(dots, function (d, i) { d.addEventListener("click", function () { aktiv = i; render(); }); });
    }
    render();
    document.body.appendChild(el);
    document.addEventListener("keydown", onKey);
    lockBody();
  }

  // ---------- Produktgalerie ----------
  var gal = document.getElementById("gallery-1");
  if (gal) {
    var stage = gal.querySelector(".pdp-offer-stage");
    var slides = stage ? stage.children : [];
    var thumbs = gal.querySelectorAll(".pdp-sub-rail button");
    var punkte = gal.querySelectorAll(".pgr-punkt");
    var shot = 0, reach = 0, count = slides.length;
    var bilder = cfg.gallery.map(function (src) { return { src: src, alt: cfg.galleryAlt }; });
    var load = function (r) {
      reach = Math.max(reach, r);
      for (var i = 0; i <= reach && i < count; i++) {
        var im = slides[i].querySelector("img[data-src]");
        if (im) { im.src = im.getAttribute("data-src"); im.removeAttribute("data-src"); }
      }
    };
    var mark = function (i) {
      shot = i;
      Array.prototype.forEach.call(thumbs, function (b, k) {
        b.setAttribute("aria-pressed", k === i ? "true" : "false");
        b.style.border = "1.5px solid " + (k === i ? "var(--lp-text)" : "var(--lp-border)");
      });
      Array.prototype.forEach.call(punkte, function (b, k) {
        b.setAttribute("aria-pressed", k === i ? "true" : "false");
        b.className = k === i ? "pgr-punkt pgr-punkt--an" : "pgr-punkt";
      });
    };
    var goShot = function (i) {
      var next = Math.max(0, Math.min(count - 1, i));
      load(next + 1);
      stage.scrollTo({ left: next * stage.clientWidth, behavior: "smooth" });
      mark(next);
    };
    if (document.readyState === "complete") load(1);
    else window.addEventListener("load", function () { load(1); }, { once: true });
    stage.addEventListener("scroll", function () {
      if (!stage.clientWidth) return;
      load(Math.ceil(stage.scrollLeft / stage.clientWidth) + 1);
      var i = Math.round(stage.scrollLeft / stage.clientWidth);
      if (i !== shot && i >= 0 && i < count) mark(i);
    }, { passive: true });
    Array.prototype.forEach.call(thumbs, function (b, i) { b.addEventListener("click", function () { goShot(i); }); });
    Array.prototype.forEach.call(punkte, function (b, i) { b.addEventListener("click", function () { goShot(i); }); });
    var prev = gal.querySelector(".pdp-offer-arrow--prev"), next = gal.querySelector(".pdp-offer-arrow--next");
    if (prev) prev.addEventListener("click", function () { goShot(shot - 1); });
    if (next) next.addEventListener("click", function () { goShot(shot + 1); });
    // Klick oeffnet die Lightbox, ausser der Finger hat gewischt (>10px).
    Array.prototype.forEach.call(slides, function (slide, i) {
      var im = slide.querySelector("img");
      if (!im) return;
      var start = null;
      im.addEventListener("pointerdown", function (e) { start = { x: e.clientX, y: e.clientY }; });
      im.addEventListener("click", function (e) {
        var s = start; start = null;
        if (s && Math.hypot(e.clientX - s.x, e.clientY - s.y) > 10) return;
        openZoom(bilder, i);
      });
    });
  }

  // ---------- Video-Lightbox (VideoModal) ----------
  function openVideo(d) {
    var el = document.createElement("div");
    el.className = "lp-vmodal";
    el.setAttribute("role", "dialog");
    el.setAttribute("aria-modal", "true");
    el.setAttribute("aria-label", d.title || "Video");
    el.innerHTML = '<button type="button" class="lp-vmodal-close" aria-label="Schließen"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M5 5l14 14M19 5 5 19"></path></svg></button>' +
      '<div class="lp-vmodal-stage"><video controls autoplay playsinline preload="metadata"></video>' + (d.title ? '<p class="lp-vmodal-title"></p>' : "") + "</div>";
    var v = el.querySelector("video");
    v.src = d.src;
    if (d.poster) v.poster = d.poster;
    if (d.title) el.querySelector(".lp-vmodal-title").textContent = d.title;
    var close = function () {
      window.removeEventListener("keydown", onKey);
      try { v.pause(); } catch (e) { /* egal */ }
      if (el.parentNode) el.parentNode.removeChild(el);
      unlockBody();
    };
    var onKey = function (e) { if (e.key === "Escape") close(); };
    el.addEventListener("click", close);
    el.querySelector(".lp-vmodal-stage").addEventListener("click", function (e) { e.stopPropagation(); });
    var btn = el.querySelector(".lp-vmodal-close");
    btn.addEventListener("click", function (e) { e.stopPropagation(); close(); });
    document.body.appendChild(el);
    lockBody();
    window.addEventListener("keydown", onKey);
    btn.focus();
  }
  Array.prototype.forEach.call(document.querySelectorAll(".bx-voice-av--play[data-video]"), function (b) {
    b.addEventListener("click", function () {
      var img = b.querySelector("img");
      openVideo({ src: b.getAttribute("data-video"), poster: b.getAttribute("data-poster") || undefined, title: img ? img.alt : "" });
    });
  });
  Array.prototype.forEach.call(document.querySelectorAll(".rw-video"), function (b) {
    var v = b.querySelector("video");
    if (!v) return;
    v.addEventListener("mouseenter", function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); });
    v.addEventListener("mouseleave", function () { v.pause(); });
    b.addEventListener("click", function () { openVideo({ src: v.getAttribute("src"), poster: v.getAttribute("poster") || undefined }); });
  });

  // ---------- Inhaltsstoffe: Detail-Dialog + Bildkarten nachladen ----------
  function openIng(i) {
    var ing = cfg.ingredients[i];
    if (!ing) return;
    var back = document.createElement("div");
    back.className = "ing-dlg-back";
    back.innerHTML = '<div class="ing-dlg" role="dialog" aria-modal="true"><div class="ing-dlg-head"><div><p class="ing-dlg-title"></p>' +
      (ing.dose ? '<p class="ing-dlg-dose"></p>' : "") +
      '</div><button type="button" class="ing-dlg-close" aria-label="Schließen"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true"><path d="M5 5l14 14M19 5 5 19"></path></svg></button></div>' +
      (ing.img ? '<div class="ing-dlg-media"><img></div>' : "") +
      '<p class="ing-dlg-body lp-display lp-no-italic"></p></div>';
    var dlg = back.querySelector(".ing-dlg");
    dlg.setAttribute("aria-label", ing.name);
    back.querySelector(".ing-dlg-title").textContent = ing.name;
    if (ing.dose) back.querySelector(".ing-dlg-dose").textContent = ing.dose;
    if (ing.img) { var im = back.querySelector(".ing-dlg-media img"); im.src = ing.img; im.alt = ing.name; }
    back.querySelector(".ing-dlg-body").textContent = ing.body;
    var close = function () {
      window.removeEventListener("keydown", onKey);
      if (back.parentNode) back.parentNode.removeChild(back);
      unlockBody();
    };
    var onKey = function (e) { if (e.key === "Escape") close(); };
    back.addEventListener("click", close);
    dlg.addEventListener("click", function (e) { e.stopPropagation(); });
    var btn = back.querySelector(".ing-dlg-close");
    btn.addEventListener("click", close);
    root.appendChild(back);
    lockBody();
    window.addEventListener("keydown", onKey);
    btn.focus();
  }
  Array.prototype.forEach.call(document.querySelectorAll(".ing-card[data-l1-ing]"), function (b) {
    b.addEventListener("click", function () { openIng(Number(b.getAttribute("data-l1-ing"))); });
  });
  var cardsWrap = document.querySelector(".ing-cards");
  if (cardsWrap) {
    var setBgs = function () {
      Array.prototype.forEach.call(cardsWrap.querySelectorAll(".ing-bigcard"), function (c, i) {
        if (cfg.cards[i]) c.style.backgroundImage = "url(" + cfg.cards[i] + ")";
      });
    };
    if ("IntersectionObserver" in window) {
      var ioCards = new IntersectionObserver(function (es) {
        if (es.some(function (x) { return x.isIntersecting; })) { setBgs(); ioCards.disconnect(); }
      }, { rootMargin: "600px 0px" });
      ioCards.observe(cardsWrap);
    } else setBgs();
  }

  // ---------- Problem-Kacheln: Zahlen zaehlen hoch ----------
  var pstGrid = document.querySelector(".pst-grid");
  if (pstGrid) {
    var vals = pstGrid.querySelectorAll(".pst-value");
    var split = function (raw) {
      var m = raw.match(/^(\D*?)([\d]+(?:[.,]\d+)?)(.*)$/);
      if (!m) return null;
      var n = m[2].replace(",", ".");
      return { pre: m[1], num: Number(n), suf: m[3], dec: n.indexOf(".") >= 0 ? n.split(".")[1].length : 0 };
    };
    var runCount = function () {
      var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      Array.prototype.forEach.call(vals, function (el, i) {
        var raw = cfg.stats[i];
        var sv = raw ? split(raw) : null;
        if (!sv) return;
        var put = function (x) { el.textContent = sv.pre + x.toFixed(sv.dec).replace(".", ",") + sv.suf; };
        if (reduce) { put(sv.num); return; }
        var t0 = performance.now();
        var tick = function (now) {
          var p = Math.min(1, (now - t0) / 1100);
          put(sv.num * (1 - Math.pow(1 - p, 3)));
          if (p < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      });
    };
    if ("IntersectionObserver" in window) {
      var ioPst = new IntersectionObserver(function (es) {
        if (es.some(function (x) { return x.isIntersecting; })) { runCount(); ioPst.disconnect(); }
      }, { threshold: 0.35 });
      ioPst.observe(pstGrid);
    } else runCount();
  }

  // ---------- Bewertungen: "Mehr anzeigen" ----------
  var more = document.querySelector(".rw-more");
  if (more) {
    more.addEventListener("click", function () {
      var hidden = document.querySelectorAll(".rw-list .rw-item[hidden]");
      for (var i = 0; i < hidden.length && i < cfg.pageSize; i++) hidden[i].hidden = false;
      if (!document.querySelector(".rw-list .rw-item[hidden]") && more.parentNode) more.parentNode.removeChild(more);
    });
  }

  // ---------- Scroll-Reveal ----------
  var SEL = ".lp-reveal, .pdp-rise";
  var markIn = function (el) { el.classList.add(el.classList.contains("pdp-rise") ? "is-in" : "lp-in"); };
  if (!("IntersectionObserver" in window)) {
    Array.prototype.forEach.call(document.querySelectorAll(SEL), markIn);
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { markIn(e.target); io.unobserve(e.target); } });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    Array.prototype.forEach.call(document.querySelectorAll(SEL), function (el) { io.observe(el); });
  }
})();
